import { RidangoReduxAction } from '@ridango/core';

import { RoutesState } from '../../schedule.model';
import { RoutesActions } from '../routes/routes.action';

export const ROUTES_STATE_KEY = 'routes';

export const ROUTES_INITIAL_STATE: RoutesState = {
    ids: [],
    dates: [],
    byDate: {},
    entities: {},
    selectedId: null,
    loading: false,
};

export function routesReducer(state: RoutesState = ROUTES_INITIAL_STATE, action: RidangoReduxAction): RoutesState {
    switch (action.type) {
        case RoutesActions.FETCH_ALL_ROUTES:
            return {
                ...state,
                loading: true,
            };
        case RoutesActions.FETCH_ALL_ROUTES_SUCCESS:
            return {
                ...state,
                ...action.payload,
                loading: false,
            };
        case RoutesActions.SET_SELECTED_ROUTE_ID:
            return {
                ...state,
                selectedId: action.payload,
            };

    }

    return state;
}
